const subsequentDogProgress: Record<
	SubsequentDogScreenNames,
	NDS.OwnerSurveyProgress["SUBSEQUENT_DOG"]
> = {
	// No progress for first screens
	SD_Picker: {
		ABOUT_YOUR_DOGS: 0,
		CHOOSING_YOUR_DOG: -1,
		UNDERSTANDING_YOUR_DOG: -1,
	},
	Q3: {
		ABOUT_YOUR_DOGS: 0,
		CHOOSING_YOUR_DOG: -1,
		UNDERSTANDING_YOUR_DOG: -1,
	},

	// Progress begins ABOUT_YOUR_DOGS
	Q4: {
		ABOUT_YOUR_DOGS: 25,
		CHOOSING_YOUR_DOG: -1,
		UNDERSTANDING_YOUR_DOG: -1,
	},
	Q6: {
		ABOUT_YOUR_DOGS: 50,
		CHOOSING_YOUR_DOG: -1,
		UNDERSTANDING_YOUR_DOG: -1,
	},
	Q6_1: {
		ABOUT_YOUR_DOGS: 75,
		CHOOSING_YOUR_DOG: -1,
		UNDERSTANDING_YOUR_DOG: -1,
	},
	Q6_2: {
		ABOUT_YOUR_DOGS: 75,
		CHOOSING_YOUR_DOG: -1,
		UNDERSTANDING_YOUR_DOG: -1,
	},
	Q6_3: {
		ABOUT_YOUR_DOGS: 90,
		CHOOSING_YOUR_DOG: -1,
		UNDERSTANDING_YOUR_DOG: -1,
	},

	// Progress begins CHOOSING_YOUR_DOG
	Q8: {
		ABOUT_YOUR_DOGS: 100,
		CHOOSING_YOUR_DOG: 0,
		UNDERSTANDING_YOUR_DOG: -1,
	},
	Q9: {
		ABOUT_YOUR_DOGS: 100,
		CHOOSING_YOUR_DOG: 33,
		UNDERSTANDING_YOUR_DOG: -1,
	},
	Q10: {
		ABOUT_YOUR_DOGS: 100,
		CHOOSING_YOUR_DOG: 66,
		UNDERSTANDING_YOUR_DOG: -1,
	},

	// Progress begins UNDERSTANDING_YOUR_DOG
	Q12: {
		ABOUT_YOUR_DOGS: 100,
		CHOOSING_YOUR_DOG: 100,
		UNDERSTANDING_YOUR_DOG: 0,
	},
	Q15: {
		ABOUT_YOUR_DOGS: 100,
		CHOOSING_YOUR_DOG: 100,
		UNDERSTANDING_YOUR_DOG: 50,
	},

	// Reaching these screens means the user has completed the survey for this dog
	Q32: {
		ABOUT_YOUR_DOGS: 100,
		CHOOSING_YOUR_DOG: 100,
		UNDERSTANDING_YOUR_DOG: 100,
	},
	Q32_1: {
		ABOUT_YOUR_DOGS: 100,
		CHOOSING_YOUR_DOG: 100,
		UNDERSTANDING_YOUR_DOG: 100,
	},
};

export const getNextScreenSubsequentDog = (
	surveyState: NDS.SurveyState,
	formData: NDS.FormData,
	questionSchema: NDS.QuestionSchema,
): NDS.RouteChange => {
	const screenState = surveyState.routeStack[surveyState.routeStack.length - 1];
	const dogsState = { ...screenState.dogsState };
	const dogIndex = Object.values(screenState.dogsState).find(
		(dog) => dog.isActive,
	)?.index as 1 | 2 | 3 | 4 | 5;

	// Would you like to tell us about another dog?
	switch (screenState.screen as SubsequentDogScreenNames) {
		case "Q32": {
			// We need to set the isActive dog to isComplete

			const [activeDogName, activeDogData] = Object.entries(
				screenState.dogsState,
			).find(([_, dogData]) => dogData.isActive);

			dogsState[activeDogName] = {
				...activeDogData,
				isComplete: true,
			};
			const remainingDogsCount = Object.values(dogsState).filter(
				(dog) => !dog.isComplete,
			)?.length;

			// They can pick their dog if there is more than one.
			if (remainingDogsCount > 1) {
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					SUBSEQUENT_DOG: subsequentDogProgress.SD_Picker,
				};
				surveyState.routeStack.push({
					...screenState,
					route: "SUBSEQUENT_DOG",
					screen: "SD_Picker",
					dogsState,
				});
			}

			// Otherwise we can pick the next dog for them.
			else {
				const dogNames = Object.keys(dogsState);

				const dogName = dogNames.find((name) => !dogsState[name].isComplete);

				const updatedDogState = {
					...dogsState,
				};
				for (const name of dogNames) {
					updatedDogState[name].isActive = name === dogName;
				}
				// The first question of multi-dogs so resetting multi dog progress
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					SUBSEQUENT_DOG: subsequentDogProgress.Q3,
				};

				const [_, activeDog] = Object.entries(updatedDogState).find(
					([_, dogData]) => dogData.isActive,
				);

				// Warm dog we can skip the questions for data we already know
				if (activeDog.isWarm) {
					surveyState.routeStack.push({
						...screenState,
						route: "SUBSEQUENT_DOG",
						screen: "Q6",
						dogsState: { ...updatedDogState },
					});
				} else {
					surveyState.routeStack.push({
						...screenState,
						route: "SUBSEQUENT_DOG",
						screen: "Q3",
						dogsState: { ...updatedDogState },
					});
				}
			}
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}
		case "Q32_1": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				SUBSEQUENT_DOG: subsequentDogProgress.SD_Picker,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "SUBSEQUENT_DOG",
				screen: "SD_Picker",
			});
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		case "SD_Picker": {
			const dogState = { ...screenState.dogsState };
			const dogNames = Object.keys(dogState);
			const dogName = formData.NEXT_DOG as string;
			const updatedDogState = {
				...dogState,
			};
			for (const name of dogNames) {
				updatedDogState[name].isActive = name === dogName;
			}

			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				SUBSEQUENT_DOG: subsequentDogProgress.Q3,
			};

			const [_, activeDog] = Object.entries(updatedDogState).find(
				([_, dogData]) => dogData.isActive,
			);

			// Warm dog we can skip the questions for data we already know
			if (activeDog.isWarm) {
				surveyState.routeStack.push({
					...screenState,
					route: "SUBSEQUENT_DOG",
					screen: "Q6",
					dogsState: { ...updatedDogState },
				});
			} else {
				surveyState.routeStack.push({
					...screenState,
					route: "SUBSEQUENT_DOG",
					screen: "Q3",
					dogsState: updatedDogState,
				});
			}
			return {
				surveyState,
				formData: {
					...formData,
					NEXT_DOG: undefined, // Clear the NEXT_DOG field for next time
				},
			};
		}

		// How old is [dogName]?
		case "Q3": {
			// The first question of multi-dogs so resetting multi dog progress
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				SUBSEQUENT_DOG: subsequentDogProgress.Q4,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "SUBSEQUENT_DOG",
				screen: "Q4",
			});
			return {
				surveyState,
				formData: {
					...formData,
				},
			};
		}

		// Is [dogName] female or male?
		case "Q4": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				SUBSEQUENT_DOG: subsequentDogProgress.Q6,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "SUBSEQUENT_DOG",
				screen: "Q6",
			});
			return {
				surveyState,
				formData: {
					...formData,
				},
			};
		}

		// Which of the following best describes [dogName]?
		case "Q6": {
			const breedOptions = questionSchema.ABOUT_YOUR_DOGS.Q6.fields[0].options;

			const pureBreedOption = breedOptions[0].value;
			const crossBreedOption = breedOptions[1].value;

			const selectedOption = formData[`nds_q_6_breed_type_${dogIndex}`];

			if (selectedOption === pureBreedOption) {
				// Clear the mixed breed answer if it exists
				formData[`nds_q_6_2_first_crossbreed_${dogIndex}`] = undefined;

				formData[`nds_q_6_2_first_crossbreed_unlisted_${dogIndex}`] = undefined;

				formData[`nds_q_6_2_second_crossbreed_${dogIndex}`] = undefined;

				formData[`nds_q_6_2_second_crossbreed_unlisted_${dogIndex}`] =
					undefined;

				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					SUBSEQUENT_DOG: subsequentDogProgress.Q6_1,
				};

				surveyState.routeStack.push({
					...screenState,
					route: "SUBSEQUENT_DOG",
					screen: "Q6_1",
				});
				return {
					surveyState,
					formData,
				};
			}
			if (selectedOption === crossBreedOption) {
				// Clear the single breed answer if it exists
				formData[`nds_q_6_1_single_breed_${dogIndex}`] = undefined;
				formData[`nds_q_6_1_single_breed_unlisted_${dogIndex}`] = undefined;

				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					SUBSEQUENT_DOG: subsequentDogProgress.Q6_2,
				};

				surveyState.routeStack.push({
					...screenState,
					route: "SUBSEQUENT_DOG",
					screen: "Q6_2",
				});
				return {
					surveyState,
					formData,
				};
			}

			// Else it must be unknown mix

			// Clear the mixed breed answer if it exists
			formData[`nds_q_6_2_first_crossbreed_${dogIndex}`] = undefined;

			formData[`nds_q_6_2_first_crossbreed_unlisted_${dogIndex}`] = undefined;

			formData[`nds_q_6_2_second_crossbreed_${dogIndex}`] = undefined;

			formData[`nds_q_6_2_second_crossbreed_unlisted_${dogIndex}`] = undefined;

			// Clear the single breed answer if it exists
			formData[`nds_q_6_1_single_breed_${dogIndex}`] = undefined;
			formData[`nds_q_6_1_single_breed_unlisted_${dogIndex}`] = undefined;

			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				SUBSEQUENT_DOG: subsequentDogProgress.Q6_3,
			};

			surveyState.routeStack.push({
				...screenState,
				route: "SUBSEQUENT_DOG",
				screen: "Q6_3",
			});
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// What is [dogName]'s breed?
		case "Q6_1": {
			const userAnswer = formData[`nds_q_6_1_single_breed_${dogIndex}`];

			if (
				!userAnswer ||
				["Breed not listed", "Unknown breed", "Prefer not to say"].includes(
					userAnswer as string,
				)
			) {
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					SUBSEQUENT_DOG: subsequentDogProgress.Q6_3,
				};

				// We want to get an idea of the size of the dog
				surveyState.routeStack.push({
					...screenState,
					route: "SUBSEQUENT_DOG",
					screen: "Q6_3",
				});
				return {
					surveyState,
					formData,
				};
			}

			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				SUBSEQUENT_DOG: subsequentDogProgress.Q8,
			};
			// We know the size of the dog from the breed
			surveyState.routeStack.push({
				...screenState,
				route: "SUBSEQUENT_DOG",
				screen: "Q8",
			});
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// What is [dogName]'s breed mix?
		case "Q6_2": {
			// We always want to know the size of the dog for any crossbreed
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				SUBSEQUENT_DOG: subsequentDogProgress.Q6_3,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "SUBSEQUENT_DOG",
				screen: "Q6_3",
			});
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		// What size is [dogName]? Or if they are not fully developed how big do you think they will be?
		case "Q6_3": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				SUBSEQUENT_DOG: subsequentDogProgress.Q8,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "SUBSEQUENT_DOG",
				screen: "Q8",
			});
			return {
				surveyState: { ...surveyState },
				formData: { ...formData },
			};
		}

		case "Q8": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				SUBSEQUENT_DOG: subsequentDogProgress.Q9,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "SUBSEQUENT_DOG",
				screen: "Q9",
			});
			return {
				surveyState,
				formData: {
					...formData,
				},
			};
		}

		case "Q9": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				SUBSEQUENT_DOG: subsequentDogProgress.Q10,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "SUBSEQUENT_DOG",
				screen: "Q10",
			});
			return {
				surveyState,
				formData: {
					...formData,
				},
			};
		}

		case "Q10": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				SUBSEQUENT_DOG: subsequentDogProgress.Q12,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "SUBSEQUENT_DOG",
				screen: "Q12",
			});
			return {
				surveyState,
				formData: {
					...formData,
				},
			};
		}

		case "Q12": {
			surveyState.surveyProgress = {
				...surveyState.surveyProgress,
				SUBSEQUENT_DOG: subsequentDogProgress.Q15,
			};
			surveyState.routeStack.push({
				...screenState,
				route: "SUBSEQUENT_DOG",
				screen: "Q15",
			});
			return {
				surveyState,
				formData: {
					...formData,
				},
			};
		}

		case "Q15": {
			const remainingDogsCount = Object.values(dogsState).filter(
				(dog) => !dog.isComplete,
			)?.length;

			if (remainingDogsCount > 1) {
				// If there are more dogs we can ask them if they want to tell us about them
				surveyState.surveyProgress = {
					...surveyState.surveyProgress,
					SUBSEQUENT_DOG: subsequentDogProgress.Q32,
				};
				surveyState.routeStack.push({
					...screenState,
					route: "SUBSEQUENT_DOG",
					screen: "Q32",
				});
			} else {
				// Otherwise it's the end of the survey screen where they can submit [PROGRESS IS HIDDEN]
				surveyState.routeStack.push({
					...screenState,
					route: "GLOBAL",
					screen: "END_OF_SURVEY",
				});
			}
			return {
				surveyState,
				formData: {
					...formData,
				},
			};
		}
	}
};
